<template>
  <div>
    <!--Banner-->
    <div class="banner-section">
      <Slider :items="sliders" />
    </div>
    <!--Banner-->

    <!--Crime-->
    <div class="crime-section pt-60 pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("Top Games") }}</h2>
        </div>
        <GameRowSlider :items="mostViews" />
      </div>
    </div>
    <!--Crime-->

    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("Trending") }}</h2>
          <router-link to="/games" class="border-btn">
            <span>{{ $t("All games") }}</span>
          </router-link>
        </div>
        <GameCardSlider :items="mostCommented" />
      </div>
    </div>
    <!--Casino Demo-->

    <!--live Demo-->
    <div class="live-demo pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("Popular Games") }}</h2>
          <router-link to="/games" class="border-btn">
            <span>{{ $t("All games") }}</span>
          </router-link>
        </div>
        <GameCardSlider :items="mostRated" />
      </div>
    </div>
    <!--live Demo-->

    <!--Crime-->
    <div class="letest-section pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("New Games") }}</h2>
          <router-link to="/new-games" class="border-btn">
            <span>{{ $t("All games") }}</span>
          </router-link>
        </div>
        <NewGames :items="newGames" />

        <div class="more-btn text-center bt">
          <router-link to="/new-games" class="border-btn">
            <span>{{ $t("All New Games") }}</span>
          </router-link>
        </div>

      </div>
    </div>
    <!--Crime-->

    <!--Tabing Table-->
    <div class="letest-section pb-60">
      <div class="container-fluid">
        <div class="section-wrapper">
          <h2 class="left-title">{{ $t("Leaderboard") }}</h2>
        </div>
        <Leaderboard />
      </div>
    </div>
    <!--Tabing Table-->
  </div>
</template>

<script>
import { useHomeStore } from "@/store/home";
import { mapState, mapActions } from "pinia";
import Slider from "@/components/partials/Slider.vue";
import GameRowSlider from "@/components/partials/GameRowSlider.vue";
import GameCardSlider from "@/components/partials/GameCardSlider.vue";
import NewGames from "@/components/partials/GameRoundedSlider.vue";
import Leaderboard from "@/components/partials/Leaderboard.vue";

export default {
  inject: ["isRtlLayout"],
  name: "HomePage",
  components: {
    Slider,
    GameRowSlider,
    GameCardSlider,
    NewGames,
    Leaderboard,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(useHomeStore, [
      "sliders",
      "newGames",
      "mostViews",
      "mostRated",
      "mostCommented",
    ]),
  },
  methods: {
    ...mapActions(useHomeStore, ['fetchHomePageData']),
  },
  async created () {
    await this.fetchHomePageData()
  }
};
</script>
